<template>
  <div
    class="hera-form-checkbox"
    :class="{ disabled }"
    @click="$emit('click', $event)"
  >
    <label class="label-checkbox ">
      <input
        type="checkbox"
        :class="{ indeterminate }"
        :name="name"
        :value="val"
        :checked="isChecked"
        :title="label"
        :tabindex="tabindex"
        @change="onChange"
      />
      <span class="hera-checkbox"></span>
      <span class="new-checkbox-text">
        {{ label }}
        <slot />
      </span>
    </label>
    <span
      v-show="error"
      class="form-text text-danger error-helper ml-5 p-0"
      v-text="error"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'HeraCheckbox',
  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    val: {
      type: null,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      return this.value.includes(this.val) || this.checked;
    },
  },
  methods: {
    onChange() {
      if (this.isChecked) {
        this.value.splice(this.value.findIndex(el => el === this.val), 1);
      } else {
        this.value.push(this.val);
      }
      this.$emit('change', ...this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.hera-form-checkbox {
  display: flex;
  flex-direction: column;
  width: 100%;
  > .label-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    span {
      padding: 0;
      background: transparent;
      &:checked {
        ~ .hera-checkbox::before {
          padding: 0;
          background-color: #36f9d7;
          background-image: url('~@/assets/images/playhera-indo/Checkbox.svg');
        }
      }
    }
    input {
      &:checked {
        ~ .hera-checkbox::before {
          padding: 0;
          background-color: #36f9d7;
          background-image: url('~@/assets/images/playhera-indo/Checkbox.svg');
        }
      }
      &.indeterminate {
        ~ .hera-checkbox::before {
          background-image: url('~@/assets/images/playhera-indo/Checkbox.svg');
        }
      }
    }
  }
  label {
    margin: 0;
  }
}
</style>
